import React from 'react'
import ContentLoader from 'react-content-loader'

const FallbackCards = props => {
    // Get values from props
    // const { rows, columns = 3, coverHeight = 405, coverWidth = 385, padding, speed } = props;
    const { rows = 4, columns = 3, coverHeight = 305, coverWidth = 385, padding = 55, speed = 1 } = props;

    // Hardcoded values
    // const rows = 2
    // const columns = 3
    // const coverHeight = 405
    // const coverWidth = 385
    // const padding = 5
    // const speed = 1

    const coverHeightWithPadding = coverHeight + padding
    const coverWidthWithPadding = coverWidth + padding
    const initial = 35
    const covers = Array(columns * rows).fill(1)

    return (
        <div className='fallback__container'>

            <ContentLoader
                speed={speed}
                // width={columns * coverWidthWithPadding}
                // height={rows * coverHeightWithPadding}
                className='fallback__cards'
                // primaryColor="#242b34"
                // secondaryColor="#343d4c"
                {...props}
            >
                <rect
                    x="0"
                    y="0"
                    rx="0"
                    ry="0"
                    width={columns * coverWidthWithPadding - padding}
                    height="20"
                    className='fallback__card'
                />

                {covers.map((g, i) => {
                    let vy = Math.floor(i / columns) * coverHeightWithPadding + initial
                    let vx = (i * coverWidthWithPadding) % (columns * coverWidthWithPadding)
                    return (
                        <rect
                            key={i}
                            x={vx}
                            y={vy}
                            rx="0"
                            ry="0"
                            width={coverWidth}
                            height={coverHeight}
                        />
                    )
                })}
            </ContentLoader>
        </div>
    )
}

FallbackCards.metadata = {
    name: 'Pratik Pathak',
    github: 'PathakPratik',
    description: 'Netflix Style Dynamic',
    filename: 'Netflix',
}

export default FallbackCards